import { ConfirmGroupsTable } from "./components/ConfirmGroupsTable";
import { Dispatch, FC } from "react";
import { PropertyGroupSplitBy } from "views/property-groups-configuration/types";
import { PropertyGroup as PropertyGroupCamelCase } from "views/property-groups-configuration/helpers/group_tree";

interface ConfirmGroupsSliceProps {
  selectedTemplates: { id: string; verification_template_id: string }[];
  setSelectedTemplates: Dispatch<
    React.SetStateAction<
      {
        id: string;
        verification_template_id: string;
      }[]
    >
  >;
  selectedSplitOptions: PropertyGroupSplitBy[];
  groups: PropertyGroupCamelCase[];
}

export const ConfirmGroupsSlice: FC<ConfirmGroupsSliceProps> = ({
  selectedTemplates,
  setSelectedTemplates,
  selectedSplitOptions,
  groups
}) => {
  return (
    <div className="space-y-6">
      <div className="space-y-3">
        <h3 className="font-bold text-2xl">
          Confirm groups and assign screening templates{" "}
        </h3>
        <p className="text-sm text-content-400 flex gap-2">
          Please assign screening templates to groups and press
          &quot;Confirm&quot; when you are finished
        </p>
      </div>

      <ConfirmGroupsTable
        isLoading={false}
        groups={groups}
        selectedTemplates={selectedTemplates}
        setSelectedTemplates={setSelectedTemplates}
        selectedSplitOptions={selectedSplitOptions}
      />
    </div>
  );
};
